import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-fi",
  "use": "icon-icon-fi-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-fi\">\n  <path fill=\"#fff\" d=\"M0 0h512v512H0z\" />\n  <path fill=\"#002f6c\" d=\"M0 186.2h512v139.6H0z\" />\n  <path fill=\"#002f6c\" d=\"M123.2 0h139.6v512H123.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol